<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'accountData.title' | translate"
      [subtitle]="'accountData.important' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="accountDataBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "accountData.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "accountData.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="accountDataBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #accountDataBlock>
  <form [formGroup]="accountDataForm">
    <div left-content class="content-container">
      <app-file-list
        [control]="accountData"
        [isSummary]="isSummary"
        [uploaderName]="assetName.ACCOUNT_DATA"
        [uploadedFileLabel]="'accountData.uploadedFileLabel'"
        [applicationId]="applicationId"
        *ngIf="isSummary"
      >
      </app-file-list>
      <ng-container *ngIf="market !== 'nl'">
        <div class="tab-container" [ngClass]="{ 'active-manual': tab === 2 }">
          <div class="tab tab-left" [ngClass]="{ 'tab-active': tab === 1 }">
            <input
              type="radio"
              id="left-summary"
              [value]="1"
              [(ngModel)]="tab"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="left-summary">{{
              "accountData.leftTabLabel" | translate
            }}</label>
          </div>
          <div class="tab tab-right" [ngClass]="{ 'tab-active': tab === 2 }">
            <input
              type="radio"
              id="right-summary"
              [value]="2"
              [(ngModel)]="tab"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="right-summary">{{
              "accountData.rightTabLabel" | translate
            }}</label>
          </div>
        </div>
      </ng-container>
      <div *ngIf="tab === 1">
        <button
          mat-flat-button
          disableRipple
          class="klarna-uploader-button"
          (click)="launchKlarnaXS2App()"
        >
          {{
            (applicationService.klarnaUpload
              ? "accountData.klarna.uploadedFileLabel"
              : "accountData.klarna.uploadLabel"
            ) | translate
          }}
          <span class="icon icon-klarna"></span>
          {{ "accountData.klarna.afterLogoText" | translate }}
          <span class="icon icon-upload"></span>
        </button>
      </div>
      <div *ngIf="tab === 2">
        <app-file-uploader
          [control]="accountData"
          [controlName]="'accountData'"
          [applicationId]="applicationId"
          [uploaderName]="assetName.ACCOUNT_DATA"
          [uploadLabel]="manualUploadLabel"
          [uploadMoreLabel]="manualUploadMoreLabel"
          [uploadedFileLabel]="'accountData.uploadedFileLabel'"
          [isSummary]="isSummary"
          [onlyUpload]="isSummary"
        ></app-file-uploader>
      </div>
      <app-infobox
        [title]="'accountData.infobox.title' | translate"
        [content]="'accountData.infobox.content' | translate"
      >
      </app-infobox>
    </div>
  </form>
</ng-template>
